import React from 'react';
import { Button } from 'theme/Button';
import { LG, MD } from '@zendeskgarden/react-typography';
import { PropTypes } from 'prop-types';

function AboutWishlist({ onClose }) {
  return (
    <div style={{ maxWidth: '700px', margin: '0 auto' }}>
      <LG paddingTopMd style={{ marginBottom: 0 }} center>
        Create your wish list, and let the PipeSearch platform do the work for
        you.
      </LG>
      <MD
        paddingTopLg
        style={{ maxWidth: '600px', margin: '0 auto' }}
        noMargin
        grey
      >
        • The wish list feature allows you to submit items of interest to the
        PipeSearch intelligence database.
      </MD>
      <MD
        style={{ maxWidth: '600px', margin: '0 auto' }}
        noMargin
        grey
        paddingTopMd
      >
        • The system will identify if there are any items in the global market
        that meet your requirement and notify you in the event of a match.
      </MD>
      <MD
        style={{ maxWidth: '600px', margin: '0 auto' }}
        noMargin
        grey
        paddingTopMd
      >
        • Whether it&#39;s an item you frequently use, something you&#39;ve been
        unable to find, or an item you&#39;re just looking for a really good
        deal on, use your wish list and let PipeSearch locate what you need.
      </MD>
      <Button center spacingTop onClick={() => onClose('custom')} primary>
        Okay, Got It
      </Button>
    </div>
  );
}

AboutWishlist.propTypes = {
  onClose: PropTypes.func,
};

export default AboutWishlist;
